import { AccountModule } from './helpers/account-helper'

export default AccountModule({
	name: 'weglot',
	retrieveUrl: (companyId) => `api/company/${companyId}/weglot/account/`,
	removeUrl: (companyId, accountId) => `api/company/${companyId}/weglot/account/${accountId}/`,
	createUrl: (companyId) => `api/company/${companyId}/weglot/account/`,
})
